module.exports = __webpack_public_path__ + "img/pp01.8784ca86.png";